// Validation for restaurant form — Messages en français (Exigences 6.5, 6.6)
import type { HotelRestaurant, RestaurantErrors } from '../types/restaurant';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateRestaurantField(field: keyof HotelRestaurant, value: any): string | null {
  if (field === 'name' && (!value || String(value).trim() === '')) {
    return 'Le nom du restaurant est obligatoire';
  }
  if (field === 'manager_email' && value && !EMAIL_REGEX.test(String(value))) {
    return 'Format d\'email invalide';
  }
  if (field === 'capacity' && value !== undefined && Number(value) < 0) {
    return 'La capacité doit être positive';
  }
  if (field === 'fpt_rate' && value !== undefined && Number(value) < 0) {
    return 'Le taux FPT doit être positif';
  }
  return null;
}

export function validateRestaurantForm(data: HotelRestaurant): RestaurantErrors {
  const errors: RestaurantErrors = {};
  const fields: (keyof HotelRestaurant)[] = ['name', 'manager_email', 'capacity', 'fpt_rate'];
  for (const field of fields) {
    const err = validateRestaurantField(field, data[field]);
    if (err) errors[field] = err;
  }
  return errors;
}
